import { Palette, SemanticColors, Theme } from "@amx/ux-twoui-theming";

/**
 * A helper method for when a component might accept a colour name (eg: "themePrimary" or "neutralMed")
 * from either theme.palette or theme.semanticColors
 */
export const getColorFromCorrectPalette = (theme: Theme, color: keyof Palette | keyof SemanticColors): string => {
    return theme.palette[color] || theme.semanticColors[color];
};
